var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.block.jBox)?_c('v-sheet',{class:("pt-5 pb-4 mx-auto" + (_vm.block.jBoxElevation ? ' elevation-' + _vm.block.jBoxElevation : '')),style:(((_vm.block.jBoxBorder
          ? ("border:dashed " + (_vm.block.jBoxBorderWidth || 4) + "px " + (_vm.block.jBoxBorderColor
                ? _vm.block.jBoxBorderColor
                : _vm.block.color
                ? _vm.block.color
                : '#1C70B9'))
          : '') + ";background:" + (_vm.block.jBoxColor ? _vm.block.jBoxColor : '#fffade') + ";max-width:" + (_vm.block.jBoxWidth || 500) + "px")),attrs:{"dark":_vm.block.jBoxDark}},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }